module.exports = __webpack_public_path__ + "images/illustrations/illustration-soccer-circle@1x-f382a93aba8e68ad366964cd6c899435.webp";